import { useAuth } from "@bw/shared/hooks";
import { AuthShell, AuthStartupPending } from "../components/AuthShell";
import { SignupForm } from "../components/SignupForm";
import { useAuthedRedirect } from "../useAuthedRedirect";
import { useDocumentTitle } from "../useDocumentTitle";

/**
 * Sign-up page (owner/admin). Ported from business-v2 `(auth)/sign-up/page.tsx`.
 */
export function SignUpPage() {
  useDocumentTitle("Sign up · Badminton Warriors");
  const { loading } = useAuth();
  useAuthedRedirect();
  return (
    <AuthShell title="Create your account">
      {loading ? (
        <AuthStartupPending />
      ) : (
        <SignupForm />
      )}
    </AuthShell>
  );
}
